import { FC } from 'react';

import { IConversationBase, IMessage } from '../../../../api/types';
import { ReactComponent as AskAILogo } from '../../../../assets/icons/ask-ai-logo.svg';
import { AppAvatar } from '../../AppAvatar/AppAvatar';
import { Spinner } from '../Spinner/Spinner';

import styles from '../ChatMessage.module.scss';

interface MessageAssistantIconProps {
    conversation: IConversationBase;
    message?: IMessage;
    isProcessing?: boolean;
}

export const MessageAssistantAvatar: FC<MessageAssistantIconProps> = ({ isProcessing, conversation, message }) => {
    const appSnapshot = message?.app_snapshot || conversation.app_snapshot;

    if (appSnapshot) {
        return (
            <Spinner spin={isProcessing} isRound={false}>
                <AppAvatar {...appSnapshot} />
            </Spinner>
        );
    }

    return (
        <Spinner spin={isProcessing}>
            <AskAILogo className={styles.avatar} />
        </Spinner>
    );
};
